var scriptTag = document.getElementById('app-min');

if(!scriptTag) {
	console.log('Implementation Error: Footer script tag invalid');
}

var themeUrl = scriptTag.getAttribute('data-theme-url');

requirejs.config({
	baseUrl: themeUrl + '/assets/compiled/js',
	shim : {
		bootstrap : { deps :['jquery', 'popper'] }
	},
	paths: {
		jquery: './lib/jquery',
		jqueryUi: 'https://code.jquery.com/ui/1.12.1/jquery-ui',
		bootstrap: '../../../p4/assets/bootstrap/js/bootstrap.bundle.min',
		popper: 'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min',
		googleMaps: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAYnbMM6tcAgtDoV7vb2TRzzCzoAVS6xm4',
		matchHeight: 'https://cdnjs.cloudflare.com/ajax/libs/jquery.matchHeight/0.7.2/jquery.matchHeight-min',
		select2: 'https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.5/js/select2.min',
		scrollTo: 'https://cdnjs.cloudflare.com/ajax/libs/jquery-scrollTo/2.1.2/jquery.scrollTo.min',
		fancybox: 'https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.2.5/jquery.fancybox.min',
		aos: 'https://cdn.rawgit.com/michalsnik/aos/2.1.1/dist/aos',
		validate: 'https://cdnjs.cloudflare.com/ajax/libs/validate.js/0.12.0/validate.min',
		//log: './lib/log',
		map: './lib/map',
		accordion: './lib/accordion',
		counter: './lib/counter',
		video: './lib/video',
		videoModal: './lib/video-modal',
		tabs: './lib/tabs'
		//page modules
		//home: './app/home',
	},
	urlArgs: function (id, url) {
		if (url.indexOf('/') == 0 && url.indexOf('//') != 0) {
			var version = /v=[^&]+/.exec(document.getElementById('app-min').getAttribute('data-main'))[0];
			return (url.indexOf('?') >= 0 ? '&' : '?') + version;
		}
		return '';
	}
});


var dependencies = ['jquery', 'matchHeight', 'bootstrap'];

if (initState && initState.modules !== undefined) {
	for (var i = 0; i < initState.modules.length; i++) {
		dependencies.push(initState.modules[i]);
	}
}

requirejs(dependencies, function($, matchHeight, bootstrap, log, page) {
	
});

requirejs.config({
	paths: {
		//App specific
		//example: './app/example'
		//test: './app/test'
		slick: 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick',
		//maginfy: './app/magnifying-glass',
		validate: 'https://cdnjs.cloudflare.com/ajax/libs/validate.js/0.12.0/validate.min',
		checkout: './app/checkout',
		jqueryZoom: './lib/jquery.zoom',
	}
});

var appDependencies = ['jquery', 'slick', 'accordion', 'validate', 'checkout', 'jqueryZoom'];

if(initState && initState.modules !== undefined) {
	appDependencies.push(initState.modules);
}

requirejs(appDependencies, function($, slick, accordion, validate, checkout, jqueryZoom) {
	$('[data-role="hero"]').slick({
		autoplay: true,
		autoplaySpeed: 4000,
		adaptiveHeight: true
	});

	$('[data-role="simple-slick"]').slick();

	$('[data-role="client-slider"]').slick({
		rows: 1,
		slidesPerRow: 4,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesPerRow: 2
				}
			}
		]
	});

	//brand menu
	$('.menu-item.brand-menu, .brand-menu-modal').hover(
		function() {
			if(!$('.is-mobile').is(':visible')) {
				$('.brand-menu-modal').addClass('open');
			}
		},
		function() {
			if(!$('.is-mobile').is(':visible')) {
				$('.brand-menu-modal').removeClass('open');
			}
		}
	);
	$('.menu-item.brand-menu, [data-action="close-modal"]').on('click', function() {
			if($('.is-mobile').is(':visible')) {
				if(!$('.brand-menu-modal').hasClass('open')) {
					$('.brand-menu-modal').addClass('open');
				} else {
					$('.brand-menu-modal').removeClass('open');
				}
			}
		}
	);

	$('[data-action="toggle-menu"]').on('click', function() {
		var $mainNav = $('header section.main nav');

		if($mainNav.hasClass('open')) {
			$mainNav.removeClass('open');
		} else {
			$mainNav.addClass('open');
		}
	});

	//use menu
	$('.menu-item.use-menu, .use-menu-modal').hover(
		function() {
			if(!$('.is-mobile').is(':visible')) {
				$('.use-menu-modal').addClass('open');
			}
		},
		function() {
			if(!$('.is-mobile').is(':visible')) {
				$('.use-menu-modal').removeClass('open');
			}
		}
	);
	$('.menu-item.use-menu, [data-action="close-modal"]').on('click', function() {
			if($('.is-mobile').is(':visible')) {
				if(!$('.use-menu-modal').hasClass('open')) {
					$('.use-menu-modal').addClass('open');
				} else {
					$('.use-menu-modal').removeClass('open');
				}
			}
		}
	);

	$('.menu-item.brand-menu, .menu-item.use-menu').click(function(e) {
		e.preventDefault();
		return false;
	});

	$('[role="filter"]').click(function() {
		//$(this).closest('form').submit();
	});

	$('.woocommerce-product-gallery a').click(function(e) {
		e.preventDefault();
		var image = $('.woocommerce-product-gallery__image img.wp-post-image.magniflier');
		var $this = $(this).children();
		var attributes = [
			'data-large_image',
			'data-large_image_width',
			'data-large_image_height'
		];
		attributes.forEach(function(value) {
			//console.log(value, $this.attr(value));
			image.attr(value, $this.attr(value));
		});
		image.attr('src', $this.attr('data-large_image'));
		image.attr('srcset', '');
		$('[role="presentation"]').remove();
		$('img.magniflier').parent().zoom({url: $this.attr('data-large_image')});
	});

	$('[data-bind="slick-gallery"]').slick({
		autoplay: true,
		autoplaySpeed: 4000,
		prevArrow: '<span class="prev"></span>',
		nextArrow: '<span class="after"></span>',
		adaptiveHeight: true,
		slidesToShow: 4,
		slidesToScroll: 1,
	});

	$('[data-action="search"]').click(function(e) {
		e.preventDefault();
		if($('nav .searchbox').hasClass('open')) {
			$('nav .searchbox').removeClass('open');
		} else {
			$('nav .searchbox').addClass('open');
			$('nav .searchbox input[type="text"]').focus();
		}
	});

	$("img.magniflier").on("load", function() {
		$('[role="presentation"]').remove();
		$('img.magniflier').parent().zoom({url: $(this).attr('data-large_image')});
	});

	$('img.magniflier').parent().zoom();

	$('[data-action="clear-filters"]').on('click', function() {
		$('[type="checkbox"]').prop('checked', false);
		$('#loader').show();
		$('form[role="filter"]').submit();
	});

	$('ul.roomtypes label').on('click', function() {
		$('ul.roomtypes label').not(this).find('[type="checkbox"]').prop('checked', false);
	});
 
	//1/2 line switch button
	$('a[data-role="switch-line"]').click(function(e) {
		e.preventDefault();

		var option = $(this).data('option');

		$('#line-option-1-line').prop('checked', false);
		$('#line-option-2-line').prop('checked', false);
		$('#line-option-' + option +'-line').prop('checked', true);

		$('input[name="paged"]').val(1);
		$('#loader').show();
		$('form[role="filter"]').closest('form').submit();
	});

	//use filter
	if($('[data-role="filter-use"]').length) {
		var $optionHtml = $('[data-role="filter-use"] .row');
		var html = '';
		var option;

		$('[data-name="Use"] ul li').each(function() {
			option = $('label', this).get(0).outerHTML.replace('id="', 'id="u-').replace('for="', 'for="u-');
			html += '<div class="item col-sm-3">' + option + '</div>';
		});

		$optionHtml.html(html);

		if(html.trim() == '') {
			$('[data-role="filter-use"]').hide();
		} else {
			$('[data-role="filter-use"]').show();
		}
	}

	if($('[data-role="filter-brand"]').length) {
		var $optionBHtml = $('[data-role="filter-brand"] .row');
		var htmlB = '';
		var optionB, $label, isSelected;

		$('[data-name="brand"] ul li').each(function() {
			$label = $('label', this);
			isSelected = $('input:checked', $label).length > 0;

			optionB = $label.get(0).outerHTML.replace('id="', 'id="b-').replace('for="', 'for="b-');

			if(!$label.hasClass('not-selectable') || isSelected) {
				htmlB += '<div class="item col-sm-3">' + optionB + '</div>';
			}
		});

		var $selectedBrand = $('[data-name="brand"] input:checked');

		if($selectedBrand.is(':disabled')) {
			var $selectedUse = $('[data-name="Use"] input:checked');

			htmlB += '<div class="col-12"><strong>Please note: (' + $selectedBrand.parent().text().trim() + ') doesn’t offer any phones in: (' + $selectedUse.parent().text().trim() + ') Please select another brand.</strong></div>';
		}

		$optionBHtml.html(htmlB);

		if(htmlB.trim() == '') {
			$('[data-role="filter-brand"]').hide();
		} else {
			$('[data-role="filter-brand"]').show();
		}
	}

	//sync use filter with form filter and submit form
	$('[data-role="filter-use"] input').change(function() {
		var $useInput, formInputId, $formInput;
		var $changed = $(this);
		var allowNone = $('[data-name="Use"]').hasClass('allow-none');

		if(!allowNone) {
			$('[data-role="filter-use"] input').prop('checked', false);
			$changed.prop('checked', true);
		}

		$('[data-role="filter-use"] input').each(function() {
			$useInput = $(this);
			formInputId = $useInput.prop('id').substring(2);
			$formInput = $('#' + formInputId);

			if($useInput.prop('id') == $changed.prop('id')) {
				$formInput.prop('checked', $changed.prop('checked'));
			} else {
				$formInput.prop('checked', false);
				$useInput.prop('checked', false);
			}
		});

		//uncheck brand
		//$('input[name="brand[]"]').removeAttr('checked');
		$('input[name="paged"]').val(1);
		$('#loader').show();
		$('form[role="filter"]').closest('form').submit();
	});

	//sync use filter with form filter and submit form
	$('[data-role="filter-brand"] input').change(function() {
		var $brandInput, formInputId, $formInput;
		var $changed = $(this);
		var $parent = $changed.parents('.floating-filter');
		var selectOne = $('[data-name="brand"]').hasClass('select-one');

		if(selectOne) {
			$('[data-role="filter-brand"] input').prop('checked', false);
			$changed.prop('checked', true);
		}

		$('[data-role="filter-brand"] input', $parent).each(function() {
			$brandInput = $(this);
			formInputId = $brandInput.prop('id').substring(2);
			$formInput = $('#' + formInputId);

			if(selectOne) {
				if($brandInput.prop('id') == $changed.prop('id')) {
					$formInput.prop('checked', true);
				} else {
					$formInput.prop('checked', false);
					$brandInput.prop('checked', false);
				}
			} else {
				//match forms
				if($brandInput.prop('id') == $changed.prop('id')) {
					$formInput.prop('checked', $brandInput.prop('checked'));
				}
			}
		});

		$('input[name="paged"]').val(1);
		$('#loader').show();
		$('form[role="filter"]').closest('form').submit();
	});

	$('[data-role="toggle-further-info"]').click(function() {
		var $furtherInfo = $('.further-info');

		if($furtherInfo.is(':visible')) {
			$furtherInfo.hide();
		} else {
			$furtherInfo.show();
		}
	});

	$('form[role="filter"] input').change(function() {
		var $this = $(this);
		var $parent = $this.parents('.attribute');

		if($parent.hasClass('select-one')) {
			$('[type="checkbox"]', $parent).prop('checked', false);
			$this.prop('checked', true);
		}

		if($parent.hasClass('hotels')) {
			//clear brand and uses
			$('[data-name="brand"] input, [data-name="Use"] input').each(function() {
				$(this).prop('checked', false);
			});
		}

		$('input[name="paged"]').val(1);
		$('#loader').show();
		$('form[role="filter"]').closest('form').submit();
	});

	$('[data-role="toggle-floating-filter-options"]').click(function() {
		var $ff = $('.floating-filter');

		if($ff.hasClass('open')) {
			$ff.removeClass('open');
		} else {
			$ff.addClass('open');
		}
	});

	var $ffs = $('.floating-filter.static');
	var $fff = $('.floating-filter.fixed');

	if($ffs.length) {
		$($ffs.parent()).css({ paddingTop: (parseInt($ffs.height()) + 30) + 'px' });

		var mainTop = $('main').position().top;

		$(window).scroll(function() {
			if($(window).scrollTop() > mainTop) {
				$fff.addClass('visible');
				$('header').addClass('not-fixed');
			} else {
				$fff.removeClass('visible');
				$('header').removeClass('not-fixed');
			}
		});
	}

	$('[data-role="clear-search"]').click(function(e) {
		e.preventDefault();

		$('input[name="paged"]').val(1);
		$('#loader').show();
		$('form[role="filter"]').closest('form').submit();
	});

	if($('#searchform').length) {
		$('[data-action="search"]').hide();
	}

	$('a.page-numbers').click(function(e) {
		e.preventDefault();

		var $paged = $('input[name="paged"]');
		var requestedPageNumber = $(this).text().trim();
		var currentPageNumber = $paged.val().trim();
		var pageNumber;

		switch(requestedPageNumber) {
			case 'Previous':
				pageNumber = parseInt(currentPageNumber) - 1;
				break;
			case 'Next':
				pageNumber = parseInt(currentPageNumber) + 1;
				break;
			default:
				pageNumber = requestedPageNumber;
		}

		$paged.val(pageNumber);
		$('#loader').show();
		$('form[role="filter"]').closest('form').submit();
	});

	$('a.show-loader').click(function() {
		$('#loader').show();
	});


	var $scrollButton = $('[data-role="scroll-top"]');
	var checkScrollButtonVisible = function() {
		var windowScrollTop = $(window).scrollTop();
		var windowHeight = $(window).outerHeight();
		var contactDetailsScrollTop = $('section.contact-details').position().top;
		if(windowScrollTop > 0 &&  (windowScrollTop + windowHeight) < contactDetailsScrollTop) {
			$scrollButton.show();
		} else {
			$scrollButton.hide();
		}
	};

	$scrollButton.click(function() {
		$(window).scrollTop(0);
	});

	$(window).scroll(checkScrollButtonVisible);
	$(window).resize(checkScrollButtonVisible);
	checkScrollButtonVisible();
	
});